import React, { useContext } from 'react';
import { Link } from 'gatsby';

import styled from '@emotion/styled';
import { FirebaseContext } from '@components/Firebase';
import * as ROUTES from '@utils/routes';

const SideNav = styled.nav`
  position: fixed;
  background-color: var(--secondary);
  transition: height 600ms ease;
  color: var(--darkText);
  -webkit-overflow-scrolling: touch;

  z-index: 999;

  @media only screen and (max-width: 700px) {
    bottom: 0;
    width: 100vw;
    height: 5rem;
  }

  @media only screen and (min-width: 700px) {
    top: 0;
    width: 5rem;
    height: 100vh;
  }
`;

const NavBarNav = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  @media only screen and (max-width: 700px) {
    flex-direction: row;
  }
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  height: 5rem;
  color: var(--text);
  text-decoration: none;
  filter: grayscale(100%) opacity(0.7);
  transition: 600ms;

  :hover {
    filter: grayscale(0%) opacity(1);
    background: var(--main);
    color: var(--success);
  }

  svg,
  img {
    width: 2rem;
    min-width: 2rem;
    margin: 0 1.5rem;
  }

  img {
    border-radius: 99em;
  }

  .fa-primary {
    color: #ff7eee;
  }

  .fa-secondary {
    color: #df49a6;
  }

  .fa-primary,
  .fa-secondary {
    transition: 600ms;
  }

  @media only screen and (max-width: 700px) {
    justify-content: center;
  }
`;

const NavLogo = styled.li`
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  background: var(--main);
  color: var(--text);
  font-size: 1.5rem;
  letter-spacing: 0.3ch;
  width: 100%;
  height: 80px;

  svg {
    transform: rotate(0deg);
    transition: 600ms;
  }

  @media only screen and (max-width: 700px) {
    display: none;
  }
`;

const NavItem = styled.li`
  width: 100%;

  :last-child {
    margin-top: auto;
  }

  :hover {
    .link-text {
      transform: scale(1) translateX(4em);
      transition: transform 0ms ease-in;
    }
  }
`;

const LinkText = styled.p`
  position: fixed;
  transform: scale(0) translateX(0px);
  transition: transform 300ms ease-out;
  left: 10px;
  margin-top: 20px;
  background: var(--gray);
  padding: 5px;
  font-size: 1.25rem;

  @media only screen and (max-width: 700px) {
    display: none;
  }
`;

const Sidebar = () => {
  const { user } = useContext(FirebaseContext);
  // var items = [
  //   'u got pwned',
  //   'in da m8rix',
  //   'oh johny',
  //   'pro hax',
  //   'try hard!',
  //   'enum me',
  //   'haxr time',
  //   'eRr0R 3.4',
  //   'wake up neo',
  // ];
  // var randomWord = items[Math.floor(Math.random() * items.length)];

  return (
    <SideNav>
      <NavBarNav>
        <NavLogo className="navlogo">
          <span>wake up neo</span>
        </NavLogo>

        <NavItem>
          <LinkText className="link-text">Learn</LinkText>
          <NavLink to={ROUTES.APP_LEARN}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="space-shuttle"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
              className="svg-inline--fa fa-space-shuttle fa-w-20 fa-5x"
            >
              <g className="fa-group">
                <path
                  fill="currentColor"
                  d="M32 416c0 35.35 21.49 64 48 64h16V352H32zm154.54-232h280.13L376 168C243 140.59 222.45 51.22 128 34.65V160h18.34a45.62 45.62 0 0 1 40.2 24zM32 96v64h64V32H80c-26.51 0-48 28.65-48 64zm114.34 256H128v125.35C222.45 460.78 243 371.41 376 344l90.67-16H186.54a45.62 45.62 0 0 1-40.2 24z"
                  className="fa-secondary"
                />
                <path
                  fill="currentColor"
                  d="M592.6 208.24C559.73 192.84 515.78 184 472 184H186.54a45.62 45.62 0 0 0-40.2-24H32c-23.2 0-32 10-32 24v144c0 14 8.82 24 32 24h114.34a45.62 45.62 0 0 0 40.2-24H472c43.78 0 87.73-8.84 120.6-24.24C622.28 289.84 640 272 640 256s-17.72-33.84-47.4-47.76zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.91 0 31.94 80 0 80z"
                  className="fa-primary"
                />
              </g>
            </svg>
          </NavLink>
        </NavItem>

        {typeof window !== 'undefined' && !localStorage.getItem('authUser') && (
          <NavItem>
            <LinkText className="link-text">Pricing</LinkText>
            <NavLink>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="cat"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
                className="svg-inline--fa fa-tags fa-w-20"
              >
                <g className="fa-group">
                  <path
                    fill="currentColor"
                    d="M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
                    className="fa-primary"
                  />
                </g>
              </svg>
            </NavLink>
          </NavItem>
        )}

        <NavItem>
          <LinkText className="link-text">Blog & members</LinkText>
          <NavLink>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="alien-monster"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              className="svg-inline--fa fa-alien-monster fa-w-18 fa-9x"
            >
              <g className="fa-group">
                <path
                  fill="currentColor"
                  d="M560,128H528a15.99954,15.99954,0,0,0-16,16v80H480V176a15.99954,15.99954,0,0,0-16-16H416V96h48a16.00079,16.00079,0,0,0,16-16V48a15.99954,15.99954,0,0,0-16-16H432a15.99954,15.99954,0,0,0-16,16V64H368a15.99954,15.99954,0,0,0-16,16v48H224V80a15.99954,15.99954,0,0,0-16-16H160V48a15.99954,15.99954,0,0,0-16-16H112A15.99954,15.99954,0,0,0,96,48V80a16.00079,16.00079,0,0,0,16,16h48v64H112a15.99954,15.99954,0,0,0-16,16v48H64V144a15.99954,15.99954,0,0,0-16-16H16A15.99954,15.99954,0,0,0,0,144V272a16.00079,16.00079,0,0,0,16,16H64v80a16.00079,16.00079,0,0,0,16,16h48v80a16.00079,16.00079,0,0,0,16,16h96a16.00079,16.00079,0,0,0,16-16V432a15.99954,15.99954,0,0,0-16-16H192V384H384v32H336a15.99954,15.99954,0,0,0-16,16v32a16.00079,16.00079,0,0,0,16,16h96a16.00079,16.00079,0,0,0,16-16V384h48a16.00079,16.00079,0,0,0,16-16V288h48a16.00079,16.00079,0,0,0,16-16V144A15.99954,15.99954,0,0,0,560,128ZM224,320H160V224h64Zm192,0H352V224h64Z"
                  className="fa-secondary"
                />
                <path
                  fill="currentColor"
                  d="M160,320h64V224H160Zm192-96v96h64V224Z"
                  className="fa-primary"
                />
              </g>
            </svg>
          </NavLink>
        </NavItem>

        <NavItem>
          <LinkText className="link-text">FAQ</LinkText>
          <NavLink to="/faq">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="space-station-moon-alt"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className="svg-inline--fa fa-question fa-w-12"
            >
              <g className="fa-group">
                <path
                  fill="currentColor"
                  d="M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                  className="fa-primary"
                />
              </g>
            </svg>
          </NavLink>
        </NavItem>

        {typeof window !== 'undefined' && localStorage.getItem('authUser') && (
          <NavItem>
            <LinkText className="link-text">Create lesson</LinkText>
            <NavLink to={ROUTES.APP_CREATE_LESSON}>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="plus-square"
                class="svg-inline--fa fa-plus-square fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                  className="fa-primary"
                ></path>
              </svg>
            </NavLink>
          </NavItem>
        )}

        <NavItem>
          {!user && (
            <>
              {typeof window !== 'undefined' &&
                localStorage.getItem('authUser') && (
                  <LinkText className="link-text">Loading...</LinkText>
                )}

              {typeof window !== 'undefined' &&
                !localStorage.getItem('authUser') && (
                  <LinkText className="link-text">Login</LinkText>
                )}

              <NavLink to={ROUTES.LOGIN}>
                <svg
                  id="darkIcon"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fad"
                  data-icon="user-circle"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 496 512"
                  className="svg-inline--fa fa-user-circle fa-w-16"
                >
                  <g className="fa-group">
                    <path
                      fill="currentColor"
                      d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                      className="fa-primary"
                    />
                  </g>
                </svg>
              </NavLink>
            </>
          )}
          {!!user && (
            <>
              <LinkText className="link-text">{user.username}</LinkText>
              <NavLink to={ROUTES.APP_PROFILE}>
                <img src={user.photoURL} alt="View your profile" />
              </NavLink>
            </>
          )}
        </NavItem>
      </NavBarNav>
    </SideNav>
  );
};

export default Sidebar;
